import {
  Component,
  EventEmitter,
  Inject,
  OnInit,
  Output,
  ViewChild,
  viewChild, AfterViewInit,
} from '@angular/core'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog'
import { MatCard, MatCardHeader, MatCardTitle } from '@angular/material/card'
import { MatOption } from '@angular/material/core'
import { MatSelect, MatSelectChange } from '@angular/material/select'
import { MatButtonModule } from '@angular/material/button'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatIconModule } from '@angular/material/icon'
import { MatInputModule } from '@angular/material/input'
import { provideNgxMask } from 'ngx-mask'
import {
  MatDatepicker,
  MatDatepickerInput,
  MatDatepickerToggle,
} from '@angular/material/datepicker'
import { SnackbarCustomService } from '../../../../shared/components/snackbar/snackbar-custom.service'
import { VehicleTypeService } from '../../../../core/services/vehicle/vehicle-type/vehicle-type.service'
import { ServiceTypeService } from '../../../../core/services/service/service-type/service-type.service'
import { ServiceSpecificationService } from '../../../../core/services/service/service-specification/service-specification.service'
import { LocationService } from '../../../../core/services/location/location/location.service'
import { TariffTypeService } from '../../../../core/services/tariff/tariff-type/tariff-type.service'
import { TariffService } from '../../../../core/services/tariff/tariff/tariff.service'
import { ParadaItinerarioEditorComponent } from '../../../../shared/components/parada-itinerario-editor/parada-itinerario-editor.component'
import {
  ParadaItinerario,
  paradaToItinerarioItemProposta,
  paradasDivergem,
} from '../../../../core/models/parada-itinerario.model'
import { apenasParadasP } from '../../../../shared/utils/parada-itinerario.util'
import { DialogForkTarifarioComponent } from '../../../../shared/components/dialog-fork-tarifario/dialog-fork-tarifario.component'
import { DriverTypeService } from '../../../../core/services/driver/driver-type/driver-type.service'
import { CurrencyInputDirective } from '../../../../shared/directives/currencyInput'
import { ResponseRequestModel } from '../../../../core/models/response.model'
import { convertCurrency } from '../../../../shared/utils/utils'
import { MatCheckbox } from '@angular/material/checkbox'
import { ItinerariesItemProposalCreateComponent } from '../../../itineraries/item-proposal/itineraries-item-proposal-create/itineraries-item-proposal-create.component'
import moment from 'moment/moment'
import { IntegerInputDirective } from '../../../../shared/directives/IntegerInput'
import { DecimalInputDirective } from '../../../../shared/directives/decimalInput'
import { CommissionDividerService } from '../../../../core/services/price-quote/commission-divider/commission-divider.service'
import { SearchTariffProposalComponent } from '../../../tariff/search-tariff-proposal/search-tariff-proposal.component'
import {
  MatAccordion,
  MatExpansionPanel,
  MatExpansionPanelHeader,
  MatExpansionPanelTitle,
} from '@angular/material/expansion'
import { JsonPipe } from '@angular/common'
import { MatTooltip } from '@angular/material/tooltip'
import { MatSlideToggle } from '@angular/material/slide-toggle'

@Component({
  selector: 'item-proposal-create-form',
  imports: [
    MatProgressSpinner,
    ReactiveFormsModule,
    MatCard,
    MatCardHeader,
    MatCardTitle,
    MatOption,
    MatSelect,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    FormsModule,
    CurrencyInputDirective,
    MatCheckbox,
    ItinerariesItemProposalCreateComponent,
    IntegerInputDirective,
    MatDatepicker,
    MatDatepickerInput,
    MatDatepickerToggle,
    DecimalInputDirective,
    SearchTariffProposalComponent,
    MatExpansionPanel,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle,
    MatAccordion,
    JsonPipe,
    MatTooltip,
    MatSlideToggle,
    ParadaItinerarioEditorComponent,
  ],
  templateUrl: './item-proposal-create-form.component.html',
  styleUrl: './item-proposal-create-form.component.scss',
  providers: [
    TariffService,
    TariffTypeService,
    DriverTypeService,
    LocationService,
    ServiceTypeService,
    ServiceSpecificationService,
    VehicleTypeService,
    provideNgxMask(),
  ],
  standalone: true,
})
export class ItemProposalCreateFormComponent implements OnInit, AfterViewInit {
  constructor(
    private formBuilder: FormBuilder,
    private driverTypeService: DriverTypeService,
    private locationService: LocationService,
    private serviceTypeService: ServiceTypeService,
    private serviceSpecificationService: ServiceSpecificationService,
    private vehicleTypeService: VehicleTypeService,
    private commissionDividerService: CommissionDividerService,
    private tariffService: TariffService,
    private snackbar: SnackbarCustomService,
    private dialogRef: MatDialogRef<ItemProposalCreateFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
  ) {
    this.idClient = data.idClient
    this.period = data.period
    if (data && data.edit) {
      this.edit = true
      this.item = data.item
    }
  }

  @Output() response = new EventEmitter()
  @ViewChild(SearchTariffProposalComponent)
  SearchTariffProposalComponent!: SearchTariffProposalComponent

  datepickerStart = viewChild<MatDatepicker<any>>('dateStart')
  datepickerEnd = viewChild<MatDatepicker<any>>('dateEnd')

  edit = false
  idClient = -1
  item: any = { user: false, data: [] }
  form: FormGroup = new FormGroup({})
  loading = false
  listLocation: any[] = []
  listTypeVehicle: any[] = []
  listTypeDriver: any[] = []
  listTypeService: any[] = []
  listItineraries: any[] = []
  listServiceSpecification: any[] = []
  listCommission: any[] = [
    { value: 'T', description: 'tg.mob', disabled: false },
    { value: 'C', description: 'Cliente', disabled: true },
    { value: 'P', description: 'Personalizado', disabled: false },
  ]

  commissionDividerClient: any = {
    taxa: 0,
    divisor: 0,
    comissao: 0,
  }

  commissionDividerTg: any = {
    taxa: 0,
    divisor: 0,
    comissao: 0,
  }

  tariffSelected: any = {}

  paradas: ParadaItinerario[] = []
  paradasOriginais: ParadaItinerario[] = []
  tarifarioTemTemplate = false

  onParadasChange(list: ParadaItinerario[]): void {
    this.paradas = list
  }

  loadParadasFromTarifario(
    tarifarioId: any,
    keepUserParadas?: ParadaItinerario[],
  ): void {
    if (!tarifarioId || tarifarioId === -1 || tarifarioId === '') {
      this.paradas = keepUserParadas ?? []
      this.paradasOriginais = []
      this.tarifarioTemTemplate = false
      return
    }
    this.tariffService.getParadas(tarifarioId).subscribe({
      next: (response: ResponseRequestModel) => {
        const list = apenasParadasP(response?.data) as ParadaItinerario[]
        this.tarifarioTemTemplate = list.length > 0
        this.paradasOriginais = list.map((p) => ({ ...p }))
        this.paradas = keepUserParadas
          ? keepUserParadas.map((p) => ({ ...p }))
          : list.map((p) => ({ ...p }))
      },
      error: (err) => {
        console.error(err)
        this.paradas = keepUserParadas ?? []
        this.paradasOriginais = []
        this.tarifarioTemTemplate = false
      },
    })
  }

  private hasTarifarioSelecionado(): boolean {
    const id = this.tariffSelected?.id
    return !!id && id !== -1 && id !== ''
  }

  get editorLocation() {
    if (this.hasTarifarioSelecionado()) {
      return {
        cityOrigin: this.tariffSelected?.origin?.cidade,
        stateOrigin: this.tariffSelected?.origin?.estado,
        cityDestination: this.tariffSelected?.destination?.cidade,
        stateDestination: this.tariffSelected?.destination?.estado,
      }
    }
    const p: any = this.SearchTariffProposalComponent?.createPurchase()
    return {
      cityOrigin: p?.origin?.cidade,
      stateOrigin: p?.origin?.estado,
      cityDestination: p?.destination?.cidade,
      stateDestination: p?.destination?.estado,
    }
  }

  private deveAbrirFork(): boolean {
    if (!this.hasTarifarioSelecionado()) return false
    return paradasDivergem(this.paradasOriginais, this.paradas)
  }

  private descricaoTarifario(): string {
    const t: any = this.tariffSelected ?? {}
    const origem = t.origem ?? t.origin?.cidade ?? ''
    const destino = t.destino ?? t.destination?.cidade ?? ''
    const servico = t.servico ?? ''
    const parts = [
      origem && destino ? `${origem} → ${destino}` : origem || destino,
      servico,
    ].filter(Boolean)
    return parts.join(' • ') || ''
  }

  private abrirDialogFork(model: any): void {
    const dialogRef = this.dialog.open(DialogForkTarifarioComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      width: '820px',
      maxWidth: '95vw',
      data: {
        tarifarioCodigo: this.tariffSelected?.id,
        tarifarioDescricao: this.descricaoTarifario(),
        paradasAntes: this.paradasOriginais,
        paradasDepois: this.paradas,
        mode: 'proposta',
      },
    })
    dialogRef.afterClosed().subscribe((confirm: boolean | undefined) => {
      if (!confirm) {
        this.loading = false
        return
      }
      this.response.emit({
        ...model,
        tarifarioId: null,
      })
      this.close()
    })
  }

  period: any = {
    dataInicio: '',
    dataFim: '',
    dataInicioDescription: '',
    dataFimDescription: '',
  }

  ngOnInit(): void {
    // this.getLocation()
    // this.getTypeService()
    // this.getTypeVehicle()
    // this.getTypeDriver()
    this.createForm()
    this.getCommissionDivider()
    this.getCommissionDivider(this.idClient)
    // if (this.edit) {
    //   this.fillForm(this.item)
    // }
  }

  ngAfterViewInit(): void {
    if (this.edit) {
      // if (this.item.tarifario.id == '' || !this.item.tarifario.id) {
      //   if (this.SearchTariffProposalComponent) {
      //     this.SearchTariffProposalComponent.fillPurchase()
      //   }
      // }
      this.fillForm(this.item)
    }
  }

  getCommissionDivider(id = -1) {
    if (id == -1) {
      this.commissionDividerService.getCommissionDividerDefault().subscribe({
        next: (response: ResponseRequestModel) => {
          // this.commissionDividerTg = {
          //   taxa: response.data.taxa,
          //   divisor: response.data.divisor,
          //   comissao: response.data.comissao,
          // }
          this.commissionDividerTg = {
            taxa:
              response && response.data && response.data.taxa
                ? response.data.taxa
                : 0,
            divisor:
              response && response.data && response.data.divisor
                ? response.data.divisor
                : 1,
            comissao:
              response && response.data && response.data.comissao
                ? response.data.comissao
                : 0,
          }
          if (!this.edit) {
            this.fillCommission(this.commissionDividerTg)
          }
        },
        error: (err: ResponseRequestModel) => {
          console.error(err)
        },
        complete: () => {},
      })
    } else {
      this.commissionDividerService
        .getCommissionDividerbyClientId(id)
        .subscribe({
          next: (response: ResponseRequestModel) => {
            if (response.data) {
              this.commissionDividerClient = {
                taxa:
                  response && response.data && response.data.taxa
                    ? response.data.taxa
                    : 0,
                divisor:
                  response && response.data && response.data.divisor
                    ? response.data.divisor
                    : 1,
                comissao:
                  response && response.data && response.data.comissao
                    ? response.data.comissao
                    : 0,
              }
              this.listCommission[1].disabled = false
              if (!this.edit) {
                this.form.get('typeCommission')!.setValue('C')
                this.fillCommission(this.commissionDividerClient)
              }
            } else {
              this.commissionDividerClient = {
                taxa: 0,
                divisor: 0,
                comissao: 0,
              }
              this.listCommission[1].disabled = true
              if (!this.edit) {
                this.fillCommission(this.commissionDividerTg)
                this.form.get('typeCommission')!.setValue('T')
              }
            }
          },
          error: (err: ResponseRequestModel) => {
            console.error(err)
          },
          complete: () => {},
        })
    }
  }

  fillCommission(commission: any, clear = false) {
    if (clear == false) {
      this.form
        .get('commission')!
        .setValue(convertCurrency(commission.comissao))
      this.form.get('commission')!.disable()
      this.form.get('tax')!.setValue(convertCurrency(commission.taxa))
      this.form.get('tax')!.disable()
      this.form.get('divider')!.setValue(convertCurrency(commission.divisor))
      this.form.get('divider')!.disable()
    } else {
      this.form.get('commission')!.setValue(convertCurrency(1))
      this.form.get('commission')!.enable()
      this.form.get('tax')!.setValue(convertCurrency(1))
      this.form.get('tax')!.enable()
      this.form.get('divider')!.setValue(convertCurrency(1))
      this.form.get('divider')!.enable()
    }
  }

  onSelectionChangeType(event: MatSelectChange) {
    if (event.value == 'T') {
      this.fillCommission(this.commissionDividerTg)
    } else if (event.value == 'C') {
      this.fillCommission(this.commissionDividerClient)
    } else {
      this.fillCommission('', true)
    }
    this.calculateValues()
  }

  getLocation() {
    this.locationService.listLocation().subscribe({
      next: (response: ResponseRequestModel) => {
        this.listLocation = response.data
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
      complete: () => {},
    })
  }

  getTypeService() {
    this.serviceTypeService.listServiceType().subscribe({
      next: (response: ResponseRequestModel) => {
        this.listTypeService = response.data
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
      complete: () => {},
    })
  }

  getTypeVehicle() {
    this.vehicleTypeService.listVehicleType().subscribe({
      next: (response: ResponseRequestModel) => {
        this.listTypeVehicle = response.data
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
      complete: () => {},
    })
  }

  getTypeDriver() {
    this.driverTypeService.listDriverType().subscribe({
      next: (response: ResponseRequestModel) => {
        this.listTypeDriver = response.data
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
      complete: () => {},
    })
  }

  createItemProposal() {
    this.loading = true
    if (this.validItem()) {
      const model: any = this.createModel()
      if (this.paradas.length > 0) {
        const origemEntry = (this.listItineraries ?? []).find(
          (i: any) => i.trecho === 'O',
        )
        const destinoEntry = (this.listItineraries ?? []).find(
          (i: any) => i.trecho === 'D',
        )
        const paradasP = this.paradas
          .filter((p) => (p.trecho ?? 'P') === 'P')
          .map(paradaToItinerarioItemProposta)
        const merged = [
          ...(origemEntry ? [origemEntry] : []),
          ...paradasP,
          ...(destinoEntry ? [destinoEntry] : []),
        ]
        model.itinerarios = merged
        model.intinerarios = merged
      }
      if (this.deveAbrirFork()) {
        this.abrirDialogFork(model)
        return
      }
      this.response.emit(model)
      this.close()
    } else {
      this.snackbar.info(
        'Para compras/cotação é necessário origem e destino ter cidade e estado, tipo de serviço e serviço.',
      )
      this.loading = false
    }
  }

  validItem() {
    if (this.tariffSelected.id) {
      return true
    } else {
      const element: any = this.SearchTariffProposalComponent.createPurchase()
      const destination: any = element.destination
      const origin: any = element.origin
      if (
        // destination.cep == '' ||
        // destination.logradouro == '' ||
        // destination.numero == '' ||
        // destination.bairro == '' ||
        destination.cidade == '' ||
        destination.estado == '' ||
        // origin.bairro == '' ||
        // origin.cep == '' ||
        // origin.logradouro == '' ||
        // origin.numero == '' ||
        origin.cidade == '' ||
        origin.estado == '' ||
        element.servicoId == 0 ||
        element.servicoId == '' ||
        element.tipoServicoId == 0 ||
        element.tipoServicoId == ''
      ) {
        return false
      }
      return true
    }
  }

  checkForm() {
    if (this.form.valid) {
      return true
    } else {
      return false
    }
  }

  close() {
    this.dialogRef.close()
  }

  fillForm(item: any) {
    if (item) {
      this.tariffSelected = item.tarifario
      if (item.tarifario.id == '' || !item.tarifario.id) {
        if (this.SearchTariffProposalComponent) {
          this.SearchTariffProposalComponent.fillPurchase(item.tarifario)
        }
      }

      this.form.get('cost')!.setValue(item.custo)
      // this.form.get('costOvertime')!.setValue(item.custoHoraExtra)
      // this.form.get('costKmExtra')!.setValue(item.custoKmExtra)

      this.form.get('saleUnit')!.setValue(item.vendaUnitario)
      this.form.get('saleOvertime')!.setValue(item.saleHoraExtra)
      this.form.get('saleKmExtra')!.setValue(item.saleKmExtra)

      this.form.get('dateStart')!.setValue(item.dataInicio)
      this.form.get('timeStart')!.setValue(item.horaInicio)
      this.form.get('dateEnd')!.setValue(item.dataFinal)
      this.form.get('timeEnd')!.setValue(item.horaFinal)

      this.form.get('isCourtesy')!.setValue(item.isCortesia)
      this.form.get('isCommission')!.setValue(item.isComisionado)
      this.form.get('isExchange')!.setValue(item.isPermuta)

      this.form.get('numVehicle')!.setValue(item.numVeiculos)
      this.form.get('numPeople')!.setValue(item.numPessoas)

      this.form.get('saleTotal')!.setValue(item.vendaSemTaxa)
      this.form.get('observation')!.setValue(item.observacao)
      this.form
        .get('mostrarObsPdf')!
        .setValue(item.mostrarObsPdf == 'S' ? true : false)
      this.form.get('taxValue')!.setValue(item.valorTaxa)
      this.form.get('saleTotalTax')!.setValue(item.venda)

      this.listItineraries = item.intinerarios

      const paradasDoItem: ParadaItinerario[] = (item.intinerarios ?? [])
        .filter((it: any) => it.trecho === 'P')
        .map((it: any, idx: number) => ({
          ...it,
          localParada: it.localParada ?? it.descricao ?? '',
          ordem: it.ordem ?? idx + 1,
        }))
      if (item.tarifario?.id) {
        this.loadParadasFromTarifario(item.tarifario.id, paradasDoItem)
      } else if (paradasDoItem.length > 0) {
        this.paradas = paradasDoItem
      }

      this.form.get('typeCommission')!.setValue(item.tipoComissao)
      this.fillCommission({
        taxa: item.taxa,
        divisor: item.divisor,
        comissao: item.comissao,
      })

      if (item.tipoComissao == 'P') {
        this.form.get('commission')!.enable()
        this.form.get('tax')!.enable()
        this.form.get('divider')!.enable()
      }

      this.blockField(true)
    }
  }

  createModel() {
    let model = {}
    if (
      this.tariffSelected.id &&
      this.tariffSelected.id != '' &&
      this.tariffSelected.id != null &&
      this.tariffSelected.id != -1
    ) {
      model = {
        origem: this.tariffSelected.origem,
        destino: this.tariffSelected.destino,
        tipoServico: this.tariffSelected.tipoServico,
        servico: this.tariffSelected.servico,
        tipoVeiculo: this.tariffSelected.tipoVeiculo,
        tipoMotorista: this.tariffSelected.tipoMotorista,

        tarifario: this.tariffSelected,
        tarifarioId: this.tariffSelected.id,
        tipoTarifarioId: this.tariffSelected.tipoId,

        origemId: this.tariffSelected.origemId,
        destinoId: this.tariffSelected.destinoId,
        tipoServicoId: this.tariffSelected.tipoServicoId,
        servicoId: this.tariffSelected.servicoId,
        tipoVeiculoId: this.tariffSelected.tipoVeiculoId,
        tipoMotoristaId: this.tariffSelected.tipoMotoristaId,

        origin: this.tariffSelected.origin,
        destination: this.tariffSelected.destination,
        perimetroUrbano: this.tariffSelected.perimetroUrbano,
      }
    } else {
      const tarrifInfos = this.SearchTariffProposalComponent.createPurchase()

      model = {
        origem: tarrifInfos.origem,
        destino: tarrifInfos.destino,
        tipoServico: tarrifInfos.tipoServico,
        servico: tarrifInfos.servico,
        tipoVeiculo: tarrifInfos.tipoVeiculo,
        tipoMotorista: tarrifInfos.tipoMotorista,

        tarifario: tarrifInfos,
        tipoTarifarioId: tarrifInfos.tipoTarifarioId,

        origemId: tarrifInfos.origemId,
        destinoId: tarrifInfos.destinoId,
        tipoServicoId: tarrifInfos.tipoServicoId,
        servicoId: tarrifInfos.servicoId,
        tipoVeiculoId: tarrifInfos.tipoVeiculoId ?? 0,
        tipoMotoristaId: tarrifInfos.tipoMotoristaId ?? 0,

        origin: tarrifInfos.origin,
        destination: tarrifInfos.destination,
        perimetroUrbano: tarrifInfos.perimetroUrbano,
      }
    }

    model = {
      ...model,
      tipoComissao: this.form.get('typeCommission')?.value,
      comissao: this.form.get('commission')?.value,
      divisor: this.form.get('divider')?.value,
      taxa: this.form.get('tax')?.value,

      custo: this.form.get('cost')?.value ? this.form.get('cost')?.value : 0,
      custoKmExtra: this.form.get('saleKmExtra')?.value
        ? this.form.get('saleKmExtra')?.value
        : 0,
      custoHoraExtra: this.form.get('saleOvertime')?.value
        ? this.form.get('saleOvertime')?.value
        : 0,

      custoFormatado: `R$ ${this.curencyFormat('string', this.form.get('cost')?.value ?? 0)}`,
      custoKmExtraFormatado: `R$ ${this.curencyFormat('string', this.form.get('saleOvertime')?.value ?? 0)}`,
      custoHoraExtraFormatado: `R$ ${this.curencyFormat('string', this.form.get('saleKmExtra')?.value ?? 0)}`,

      vendaUnitario: this.form.get('saleUnit')?.value
        ? this.form.get('saleUnit')?.value
        : 0,
      saleHoraExtra: this.form.get('saleOvertime')?.value
        ? this.form.get('saleOvertime')?.value
        : 0,
      saleKmExtra: this.form.get('saleKmExtra')?.value
        ? this.form.get('saleKmExtra')?.value
        : 0,

      vendaUnitarioFormatado: `R$ ${this.curencyFormat('string', this.form.get('saleUnit')?.value ?? 0)}`,
      saleHoraExtraFormatado: `R$ ${this.curencyFormat('string', this.form.get('saleOvertime')?.value ?? 0)}`,
      saleKmExtraFormatado: `R$ ${this.curencyFormat('string', this.form.get('saleKmExtra')?.value ?? 0)}`,

      dataInicio: this.form.get('dateStart')?.value,
      dataInicioFormatada: moment(this.form.get('dateStart')!.value).format(
        'DD/MM/YYYY',
      ),
      horaInicio: this.form.get('timeStart')?.value,

      dataFinal: this.form.get('dateEnd')?.value,
      dataFinalFormatada: moment(this.form.get('dateEnd')!.value).format(
        'DD/MM/YYYY',
      ),
      horaFinal: this.form.get('timeEnd')?.value,

      isPermuta: this.form.get('isExchange')?.value,
      isCortesia: this.form.get('isCourtesy')?.value,
      isComisionado: this.form.get('isCommission')?.value,

      numVeiculos: parseInt(this.form.get('numVehicle')?.value),
      numPessoas: parseInt(this.form.get('numPeople')?.value),

      vendaSemTaxa: this.form.get('saleTotal')?.value
        ? this.form.get('saleTotal')?.value
        : 0,
      valorTaxa: this.form.get('taxValue')?.value
        ? this.form.get('taxValue')?.value
        : 0,
      venda: this.form.get('saleTotalTax')?.value
        ? this.form.get('saleTotalTax')?.value
        : 0,

      vendaSemTaxaFormatado: `R$ ${this.curencyFormat('string', this.form.get('saleTotal')?.value ?? 0)}`,
      valorTaxaFormatado: `R$ ${this.curencyFormat('string', this.form.get('taxValue')?.value ?? 0)}`,
      vendaFormatado: `R$ ${this.curencyFormat('string', this.form.get('saleTotalTax')?.value ?? 0)}`,

      observacao: this.form.get('observation')?.value,
      mostrarObsPdf: this.form.get('mostrarObsPdf')?.value ? 'S' : 'N',
      intinerarios: this.listItineraries,
    }
    if (this.edit) {
      model = { ...model, idCreate: this.item.idCreate }
    }

    return model
  }

  curencyFormat(type: 'string' | 'number', value: any) {
    if (type == 'string') {
      if (typeof value == 'string') {
        return value
      } else if (typeof value == 'number') {
        return convertCurrency(value)
      } else {
        return '0,00'
      }
    } else {
      if (typeof value == 'number') {
        return value
      } else if (typeof value == 'string') {
        return convertCurrency(value)
      } else {
        return 0.0
      }
    }
  }

  createForm(): void {
    this.form = this.formBuilder.group({
      tariff: [''],

      isCourtesy: [false],
      isCommission: [false],
      isExchange: [false],

      dateStart: ['', [Validators.required]],
      timeStart: [''],
      dateEnd: ['', [Validators.required]],
      timeEnd: [''],

      typeCommission: ['T'],
      commission: ['', [Validators.required]],
      divider: ['', [Validators.required]],
      tax: ['', [Validators.required]],

      numVehicle: [1, [Validators.min(1), Validators.required]],
      numPeople: [1, [Validators.min(1), Validators.required]],

      cost: ['', [Validators.required]],
      sale: [''],
      // costOvertime: ['', [Validators.required]],
      // costKmExtra: ['', [Validators.required]],

      saleUnit: ['', [Validators.required]],
      saleOvertime: ['', [Validators.required]],
      saleKmExtra: ['', [Validators.required]],

      saleTotal: ['', [Validators.required]],
      taxValue: ['', [Validators.required]],
      saleTotalTax: ['', [Validators.required]],
      observation: [''],
      mostrarObsPdf: [false],
    })
    this.blockField(true)
  }

  getList(list: any[]): void {
    if (list.length > 0) {
      const listIti = []
      for (let i = 0; i < list.length; i++) {
        const element = list[i]
        listIti.push({
          ...element,
          areaTarifario:
            element.areaTarifario == 'S' || element.areaTarifario == 's'
              ? 'S'
              : 'N',
        })
      }
      this.listItineraries = list
    } else {
      this.listItineraries = []
    }
  }

  openDatepicker(type: 'dateStart' | 'dateEnd') {
    if (type == 'dateStart') {
      this.datepickerStart()?.open()
    } else if (type == 'dateEnd') {
      this.datepickerEnd()?.open()
    }
  }

  treatmentType(typeId = 0) {
    if (typeId == 2) {
      this.form.get('typeCommission')?.setValue('P')
      // this.form.get('typeCommission')?.disable()
      this.form.get('commission')?.setValue(convertCurrency(0))
      this.form.get('commission')?.enable()
      this.form.get('divider')?.setValue(convertCurrency(1))
      this.form.get('divider')?.enable()
      this.form.get('tax')?.setValue(convertCurrency(5))
      this.form.get('tax')?.enable()
    } else {
      this.form.get('typeCommission')?.enable()
    }
  }

  selectTariff(element: any) {
    if (element.id != -1) {
      if (element.isComission) {
        this.form.get('isCommission')?.setValue(true)
      } else {
        this.form.get('isCommission')?.setValue(false)
      }
      if (element.tipoTarifarioId == 2 || element.tipoId == 2) {
        this.treatmentType(2)
      }

      this.form.get('cost')?.setValue(convertCurrency(element.custo))
      // this.form
      //   .get('costOvertime')
      //   ?.setValue(convertCurrency(element.custoHoraExtra))
      // this.form
      //   .get('costKmExtra')
      //   ?.setValue(convertCurrency(element.custokmExtra))
      this.form
        .get('saleOvertime')
        ?.setValue(convertCurrency(element.custoHoraExtra))
      this.form
        .get('saleKmExtra')
        ?.setValue(convertCurrency(element.custokmExtra))
      //this.blockField(true)
      this.calculateValues()
    } else {
      this.treatmentType()
      this.form.get('cost')?.setValue(convertCurrency(0))
      this.form.get('saleOvertime')?.setValue(convertCurrency(0))
      this.form.get('saleKmExtra')?.setValue(convertCurrency(0))
      // this.form.get('cost')?.setValue(convertCurrency(0))
      // this.form.get('costOvertime')?.setValue(convertCurrency(0))
      // this.form.get('costKmExtra')?.setValue(convertCurrency(0))
      //this.blockField()
    }
    this.tariffSelected = element
    this.calculateValues()
    this.loadParadasFromTarifario(element?.id)
  }

  locationTariff(element: any) {
    this.tariffSelected = { ...this.tariffSelected, ...element }
  }

  blockField(block = false) {
    if (block) {
      this.form.get('cost')?.disable()
      // this.form.get('costOvertime')?.disable()
      // this.form.get('costKmExtra')?.disable()

      this.form.get('sale')?.disable()
      this.form.get('saleOvertime')?.disable()
      this.form.get('saleKmExtra')?.disable()

      this.form.get('saleUnit')?.disable()
      this.form.get('saleTotal')?.disable()
      this.form.get('saleTotalTax')?.disable()
      this.form.get('taxValue')?.disable()
    } else {
      this.form.get('cost')?.enable()
      this.form.get('costOvertime')?.enable()
      this.form.get('costKmExtra')?.enable()
    }
  }

  getValueNumber(value: string | number) {
    if (typeof value == 'string') {
      return parseFloat(value.replaceAll('.', '').replaceAll(',', '.'))
    } else if (typeof value == 'number') {
      return value
    } else {
      return 0.0
    }
  }

  calculateValues() {
    let divider = this.getValueNumber(
      this.form.get('divider')?.value == '' ||
        this.form.get('divider')?.value == '0'
        ? 1
        : this.form.get('divider')?.value,
    )
    let tax = this.getValueNumber(this.form.get('tax')?.value)
    const commission = this.getValueNumber(this.form.get('commission')?.value)
    let cost = this.getValueNumber(this.form.get('cost')?.value)
    // let costKm = this.getValueNumber(this.form.get('costKmExtra')?.value)
    // let costTime = this.getValueNumber(this.form.get('costOvertime')?.value)
    const vehicles = parseInt(this.form.get('numVehicle')?.value)

    // let saleUnit = parseFloat((cost / divider).toFixed(2))
    // // let saleKm = parseFloat((costKm + costKm / divider).toFixed(2))
    // // let saleTime = parseFloat((costTime + costTime / divider).toFixed(2))
    // let sale = parseFloat((saleUnit * vehicles).toFixed(2))
    // let saleTax = parseFloat((sale + (sale * tax) / 100).toFixed(2))
    // let taxValue = parseFloat((saleTax - sale).toFixed(2))
    //
    // saleUnit = Math.ceil(!isFinite(saleUnit) ? 0 : (saleUnit ?? 0))
    // sale = Math.ceil(!isFinite(sale) ? 0 : (sale ?? 0))
    // saleTax = Math.ceil(!isFinite(saleTax) ? 0 : (saleTax ?? 0))
    // taxValue = Math.ceil(!isFinite(taxValue) ? 0 : (taxValue ?? 0))

    let saleUnit = 0
    if (typeof cost == 'string') {
      // @ts-ignore
      cost = parseFloat(cost)
    }
    if (typeof divider == 'string') {
      // @ts-ignore
      divider = parseFloat(divider)
    }
    saleUnit = cost / divider
    saleUnit = Math.ceil(!isFinite(saleUnit) ? 0 : (saleUnit ?? 0))

    let sale = 0
    sale = saleUnit * vehicles
    sale = Math.ceil(!isFinite(sale) ? 0 : (sale ?? 0))

    let taxValue = 0
    if (typeof tax == 'string') {
      // @ts-ignore
      tax = parseFloat(tax)
    }
    taxValue = (sale * tax) / 100
    taxValue = Math.ceil(!isFinite(taxValue) ? 0 : (taxValue ?? 0))

    let saleTax = sale + taxValue
    saleTax = Math.ceil(!isFinite(saleTax) ? 0 : (saleTax ?? 0))

    this.form
      .get('saleUnit')
      ?.setValue(
        isNaN(saleUnit) ? convertCurrency(0) : convertCurrency(saleUnit),
      )
    // this.form.get('saleKmExtra')?.setValue(convertCurrency(saleKm))
    // this.form.get('saleOvertime')?.setValue(convertCurrency(saleTime))

    this.form
      .get('saleTotal')
      ?.setValue(isNaN(sale) ? convertCurrency(0) : convertCurrency(sale))
    this.form
      .get('taxValue')
      ?.setValue(
        isNaN(taxValue) ? convertCurrency(0) : convertCurrency(taxValue),
      )
    this.form
      .get('saleTotalTax')
      ?.setValue(isNaN(saleTax) ? convertCurrency(0) : convertCurrency(saleTax))
  }

  checkdate() {
    const start = this.form.get('dateStart')?.value
    const end = this.form.get('dateEnd')?.value
    if (
      this.period &&
      start != '' &&
      end != '' &&
      this.period.dataFimDescription != '' &&
      this.period.dataInicioDescription
    ) {
      if (
        start >= this.period.dataInicioDescription &&
        end <= this.period.dataFimDescription
      ) {
        return true
      } else {
        return false
      }
    } else {
      return true
    }
  }

  onDateChange() {
    if (!this.checkdate()) {
      this.snackbar.warning(
        `Período do item da proposta divergente, com proposta (${this.period.dataInicio} - ${this.period.dataFim}) .`,
      )
    }
  }
}
